"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _safeConfig = require("../../packages/config/safe-config");
var _createAuthInterceptor = _interopRequireDefault(require("../common/createAuthInterceptor"));
var _createAxiosClient = _interopRequireDefault(require("../common/createAxiosClient"));
var _EOSApiError = require("./exceptions/EOSApiError");
var _useOAuthInterceptor = _interopRequireDefault(require("./middleware/useOAuthInterceptor"));
var _useReCaptchaInterceptor = _interopRequireDefault(require("./middleware/useReCaptchaInterceptor"));
var _useServiceInterceptor = _interopRequireDefault(require("./middleware/useServiceInterceptor"));
const useEOSClient = function () {
  return (0, _createAxiosClient.default)({
    baseURL: (0, _safeConfig.useSafeConfigValue)("REACT_APP_EOS_ENDPOINT"),
    headers: {
      "X-BRAND": (0, _safeConfig.useSafeConfigValue)("REACT_APP_EOS_BRAND")
    },
    onError: function (err) {
      if (!_axios.default.isAxiosError(err)) throw err;
      throw new _EOSApiError.EOSApiError(err);
    },
    requestInterceptors: [(0, _useServiceInterceptor.default)(), (0, _createAuthInterceptor.default)(), (0, _useOAuthInterceptor.default)(), (0, _useReCaptchaInterceptor.default)()]
  });
};
var _default = exports.default = useEOSClient;